import { Navigate } from "react-router-dom";
import { useAuth } from "../context/auth.tsx";

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** If set, only users with this role are allowed through */
  requiredRole?: string;
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-950">
        <div className="animate-spin h-8 w-8 border-2 border-indigo-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (user == null) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole != null && user.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
